export default __webpack_public_path__ + "static/tdic-en-d2ab337a18cf353015eda8485ade1255.mp4";